<template>
  <div class="logo-signature-three-second-content" id="identidade-visual-logo-assinatura-para-videos-3-segundos" data-search-anchor>
    <div class="title-signature-three-second-wrapper">
      <h1 class="logo-signature-three-second-title-span">
        {{ logoSignature3SecondVideosTitleSpan }}
      </h1>
      <h1 class="logo-signature-three-second-title">{{ logoSignature3SecondVideosTitle }}</h1>
    </div>
    
    <div class="signature-three-second-video-player">
      <AutoPlayVideo :src="videoSrc" />
    </div>     
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import AutoPlayVideo from '@/components/AutoPlayVideo.vue'

@Component({
  components: {
    AutoPlayVideo
  }
})
export default class LogoSignature3SecondVideosSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store) 

  get logoSignature3SecondVideosTitleSpan(): string {
    return this.getElementTitle(17, 0)
  }

  get logoSignature3SecondVideosTitle(): string {
    return this.getElementText(17, 0)
  }

  @Ref('videoElement') readonly videoElement!: HTMLVideoElement
  @Ref('videoWrapper') readonly videoWrapper!: HTMLVideoElement

  get videoSrc(): string {
    return this.getElementMedia(17, 1)
  }

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.visualIdentityPageStore.getDataPage()               
    }    
  }
}
</script>

<style lang="scss">
.logo-signature-three-second-content {
  display: grid;
  width: 100%;
  max-width: 1032px;
}

.title-signature-three-second-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.logo-signature-three-second-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.logo-signature-three-second-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}
</style>
